<template>
  <div style="max-width: 100%; margin: auto;">
    <div class="ma-auto">
      <div class="d-flex align-center my-4 justify-space-between px-2">
        <!-- <h1>1</h1> -->
        <div class="d-flex align-center">
          <v-btn to="/" color="transparent" elevation="0">
            <img src="@/assets/images/icons/chevron-right.svg" style="width: 40px" />
          </v-btn>
          <h3 style="margin-right: -18px;">تاکسی 133</h3>
        </div>

        <div>
          <h4 @click="cancel_trip_btn('t')" style="cursor: pointer;margin-left: .5rem">لغو</h4>
        </div>
      </div>
    </div>


    <div class="page-f">
      <div class="col-9" style="max-width: 100%">
        <div id="search_map" style="max-width: 100%;"></div>
        <div id="map" style="width: 100%;height: 100%"></div>
      </div>

      <section>
        <div class="d-flex justify-space-between align-center px-3 mb-3">
          <h3>
            <span class="text--darken-2">
              مسافر:
              <br>
            </span>
            {{ newservice_data.nickname }}
          </h3>
          <v-btn style="background-color:#d8f4e4" class="py-6">
            <a :href="'tel:' + newservice_data.mobile" style="color: #212121;text-decoration: none">
              <img src="@/assets/images/icons/phone.png" style="width:20px; color:#18cc84;" alt="">
              <span style="font-size:18px; font-weight: bold; padding: 0 5px">تماس</span>
            </a>
          </v-btn>
        </div>


        <div class="d-flex justify-space-between mb-1" style="padding: 0 10px">
          <div v-if="service_status === 'moving_to_origin' && !loading" @click="arrive_btn()" elevation="2"
            class="bottom-btns blue darken-1">
            <h4>اعلام رسیدن</h4>
          </div>

          <div v-if="service_status === 'moving_to_origin' && loading" elevation="2" class="bottom-btns blue darken-1"
            style="cursor: not-allowed">
            <h4>
              <v-icon size="35" color="white darken-1">mdi-loading mdi-spin</v-icon>
              <span class="mr-1">اعلام رسیدن</span>
            </h4>
          </div>

          <div v-if="service_status === 'waiting_customer' && !loading" @click="startservice_btn()" elevation="2"
            class="bottom-btns blue darken-1">
            <h4>پذیرش مسافر</h4>
          </div>

          <div v-if="service_status === 'waiting_customer' && loading" elevation="2" class="bottom-btns blue darken-1"
            style="cursor: not-allowed">
            <h4>
              <v-icon size="-1" color="white darken-1">mdi-loading mdi-spin</v-icon>
              <span class="mr-1"> پذیرش مسافر</span>
            </h4>
          </div>


          <div v-if="service_status === 'moving' && !loading" @click="endservice_btn_form()" elevation="2"
            class="bottom-btns blue darken-1">
            <h4>پایان سفر</h4>
          </div>

          <div v-if="service_status === 'moving' && loading" elevation="2" class="bottom-btns blue darken-1"
            style="cursor: not-allowed">
            <h4>
              <v-icon size="35" color="white darken-1">mdi-loading mdi-spin</v-icon>
              <span class="mr-1">پایان سفر</span>
            </h4>
          </div>

          <div elevation="2" class="bottom-btns grey lighten-1" @click="masiryabi()">
            <h4 class="d-flex justify-center"> <span>مسیریابی</span> <img src="@/assets/images/icons/arrow-left-top.svg"
                class="mr-1 ml-1 " style="width:25px; color:#18cc84;" alt=""></h4>
          </div>


          <div elevation="2" class="bottom-btns pink accent-3 " @click="travel_detail()">
            <h4>جزئیات سفر</h4>

          </div>

        </div>

      </section>
    </div>

    <v-snackbar color="green" style="z-index: 1050" v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          بستن
        </v-btn>
      </template>
    </v-snackbar>


    <v-snackbar color="red" style="z-index: 1050" v-model="snackbar2">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar2 = false">
          بستن
        </v-btn>
      </template>
    </v-snackbar>

    <!--    end_service_form-->

    <v-bottom-sheet style="z-index: 1050" v-model="end_service_form">
      <v-sheet class="text-center custom-sheet">
        <div class="text-center">
          <font-awesome-icon @click="end_service_form = false" size="lg" :icon="['fas', 'chevron-down']" />
        </div>
        <div style="" class="mx-5">
          <div style="padding: 10px">
            <div class="d-flex justify-space-between">
              <div class="d-flex justify-space-between align-center">
                <img src="@/assets/images/icons/alarm.svg" style="width:20px; margin-left:6px; ">
                <h3 class="py-3 op-size"> توقف در مسیر</h3>
              </div>
              <!-- <h3 class="grey--text py-5">ایستگاه سرویس دستی</h3> -->
              <input type="text" @keypress="isNumber()" maxlength="3" v-model="StopMinutes"
                @keyup="CalculateKM('stop_price')" value="" class="my-2 text-center"
                style="background-color:#e0e4ec; border-radius:8px; width:150px;">
            </div>
            <hr />
            <div class="d-flex justify-space-between">
              <div class="d-flex justify-space-between align-center">
                <img src="@/assets/images/icons/swap-horizontal.svg" style="width:20px; margin-left:6px; ">
                <h3 class="py-3 op-size"> رفت و برگشت</h3>
              </div>

              <v-switch style="margin-top: 10px !important;" v-model="ExchangeBTN" hide-details inset></v-switch>
            </div>
            <hr />
            <div class="d-flex justify-space-between">
              <div class="d-flex justify-space-between align-center">
                <img src="@/assets/images/icons/briefcase-arrow-up-down.svg" style="width:20px; margin-left:6px; ">
                <h3 class="py-3 op-size"> اضافه بار</h3>
              </div>
              <v-switch style="margin-top: 10px !important;" v-model="hasCargo" hide-details inset
                @click="CalculateKM('cargo')"></v-switch>
            </div>

            <!-- <v-btn @click="endservice_btn()" style="font-size: 1rem;width: 100%; color:white;
                 background-color: #08d474; padding:20px; border-radius:10px;
                  margin-left:10px;">ثبت پایان سفر</v-btn> -->

            <div style="font-size: 1rem; width: 100%; color:white; background-color: #08d474; padding:20px; border-radius:10px; margin-left:10px; display: flex; align-items: center; justify-content: center;" v-if="!loading2" @click="endservice_btn()" elevation="2"
              class="bottom-btns blue darken-1">
              <h4>ثبت پایان سفر </h4>
            </div>

            <div
              style="font-size: 1rem; width: 100%; color:white; background-color: #08d474; padding:20px; border-radius:10px; margin-left:10px; display: flex; align-items: center; justify-content: center;"
              v-if="loading2" elevation="2" class="bottom-btns blue darken-1">
              <v-icon size="35" color="white darken-1" style="margin-right: 10px;">mdi-loading mdi-spin</v-icon>
              <h4>ثبت پایان سفر</h4>
            </div>

          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>


    <!--    routing component-->
    <v-bottom-sheet style="z-index: 1050" v-model="issheet_Routing">
      <div @click="close_modal()" class="TopStyleShowToUser"></div>
      <v-sheet class="text-center"
        :class="{ 'sheet-h-34': newservice_data.second_destination, 'sheet-h-24': !newservice_data.second_destination }"
        style="position: absolute;
                  bottom: 0; right: 0; left: 0;border-radius: 10px;">

        <div class="d-flex justify-center">
          <div class="close-btn" @click="close_modal()">

          </div>
        </div>


        <div class="d-flex flex-column  pt-2 h-100" style="overflow: auto">
          <div class="mx-4 my-1  rounded py-3 px-3 " style="background-color: #ccc" @click="routing(0)">
            <h4 style="font-weight: 600;" class="ma-1 align-self-start text-right text-darken-1">
              <span><v-icon>mdi-directions-fork</v-icon></span>
              <span CLASS="mr-1">مسیریابی تا مبدا</span>
            </h4>
          </div>
          <div class="mx-4 my-1  rounded py-3 px-3 " style="background-color: #ccc" @click="routing(1)">
            <h4 style="font-weight: 600;" class="ma-1 align-self-start text-right text-darken-1">
              <span><v-icon>mdi-directions-fork</v-icon></span>
              <span CLASS="mr-1">مسیریابی تا مقصد اول</span>
            </h4>
          </div>
          <div v-if="newservice_data.second_destination" class="mx-4 my-1 grey rounded py-3 px-3 " @click="routing(2)">
            <h4 style="font-weight: 600;" class="ma-1 align-self-start text-right text-darken-1">

              <span><v-icon>mdi-directions-fork</v-icon></span>
              <span CLASS="mr-1">مسیریابی تا مقصد دوم</span>
            </h4>
          </div>
        </div>


      </v-sheet>
    </v-bottom-sheet>

    <!--    sharing component-->
    <v-bottom-sheet style="z-index: 1050; " v-model="issheet_share">
      <v-sheet class="text-center py-2 px-2">
        <div @click="close_modal()" class="TopStyleShowToUser"></div>
        <div class="w-100 text-right mt-2 ">
          <h3>مسیریابی با</h3>
        </div>


        <v-row class="my-3" align="center">

          <v-col cols="6" class="d-flex flex-column justify-center align-center" @click="gotomap('balad')">
            <v-avatar size="70" class="text-center">
              <img src="/app/img/Balad.png">

            </v-avatar>
            <h4 class="mt-1"> بلد</h4>
          </v-col>


          <v-col cols="6" class="d-flex flex-column justify-center align-center" @click="gotomap('neshan')">
            <v-avatar size="80" class="text-center">
              <img src="/app/img/map.png">
            </v-avatar>
            <h4 class="mt-1"> دیگر نقشه ها</h4>
          </v-col>


          <!--          <v-col cols="4"  class="d-flex flex-column justify-center align-center" @click="gotomap('google')">-->
          <!--            <v-avatar size="70" class="text-center">-->
          <!--              <img src="/app/img/google.png">-->

          <!--            </v-avatar>-->
          <!--            <h4 class="mt-1">نقشه گوگل</h4>-->
          <!--          </v-col>-->

        </v-row>

      </v-sheet>
    </v-bottom-sheet>


    <!--    detail component-->
    <v-bottom-sheet style="z-index: 1050" v-model="issheet">
      <div @click="close_modal()" class="TopStyleShowToUser"></div>
      <v-sheet class="text-center" style="position: absolute;
                  bottom: 0; right: 0; left: 0;border-radius: 10px;" height="36%">

        <div class="d-flex justify-center">
          <div class="close-btn" @click="close_modal()">

          </div>
        </div>
        <div class="d-flex justify-space-between px-4">

          <div class="gray text--darken-4">
            {{ newservice_data.amount }}
            <span>تومان</span>
          </div>

          <div class="d-flex justify-center align-center">

            <h4 v-if="newservice_data.request_method == 'app'">
              <v-icon size="25" color="grey darken-4">mdi-account</v-icon>
              <span> از طرف اپ مسافر</span>
            </h4>
            <h4 v-if="newservice_data.request_method == 'manual'">
              <v-icon size="25" color="grey darken-4 ">mdi-headset</v-icon>
              <span> از طرف پشتیبان</span>
            </h4>
          </div>
        </div>


        <div class="d-flex flex-column justify-start pt-2" style="height: 9rem;overflow: auto">
          <h4 style=";font-weight: 400; color: #898989" class="ma-1 align-self-start text-right">
            <span>مبدا:</span>
            <span CLASS="mr-1">{{ newservice_data.address }}</span>
          </h4>
          <h4 style=";font-weight: 400; color: #898989" class="ma-1 align-self-start text-right">
            <span>مقصد1:</span>
            <span CLASS="mr-1">{{ newservice_data.destination }}</span>
          </h4>
          <h4 v-if="newservice_data.second_destination" style=";font-weight: 400; color: #898989"
            class="ma-1 align-self-start text-right">
            <span>مقصد2:</span>
            <span CLASS="mr-1">{{ newservice_data.second_destination }}</span>
          </h4>
        </div>

        <div class="d-flex align-center flex-wrap mt-3 px-3" style="gap:10px;font-size: 14px;margin-bottom: 1rem">


          <div class="service-option">
            <v-icon size="20" color="grey darken-4">mdi-speedometer</v-icon>
            <span>{{ newservice_data.distance }}</span> کیلومتر
          </div>

          <div class="service-option">
            <v-icon size="20" color="grey darken-4">mdi-timer-sand-full</v-icon>
            <span> <span>0</span> الی <span>{{ newservice_data.estimated_time }}</span> دقیقه</span>
          </div>

          <div v-if="newservice_data.hasReturn" class="service-option">
            <v-icon size="20" color="grey darken-4">mdi-swap-vertical</v-icon>
            <span> رفت و برگشت</span>
          </div>

          <div v-if="newservice_data.hasCargo" class="service-option">
            <v-icon size="20" color="grey darken-4">mdi-clipboard</v-icon>
            <span> اضافه بار</span>
          </div>

          <div v-if="newservice_data.hasAc" class="service-option">
            <v-icon size="20" color="grey darken-4">mdi-air-conditioner</v-icon>
            <span> کولر</span>
          </div>

        </div>
      </v-sheet>
    </v-bottom-sheet>

    <!--    cancel form-->
    <v-bottom-sheet style="z-index: 1050" v-model="iscancel">
      <div @click="close_modal()" class="TopStyleShowToUser"></div>
      <v-sheet class="text-center" style="position: absolute;
                  bottom: 0; right: 0; left: 0;border-radius: 10px;" height="36%">

        <div class="d-flex justify-center">
          <div class="close-btn" @click="cancel_trip_btn('f')">

          </div>
        </div>
        <div class="d-flex justify-center flex-column px-4">

          <div>
            <v-avatar size="70" class="text-center">
              <img src="@/assets/images/cancel.webp">
            </v-avatar>


          </div>
          <h4 class="text-center mt-2">آیا برای لغو این سرویس مطمئن هستید؟</h4>

          <!--          <input type="text" class="c-form-btns-input" placeholder="دلیل رد سرویس را وارد کنید">-->
          <v-text-field label="دلیل رد سرویس را وارد کنید" v-model="description">

          </v-text-field>
          <div class="d-flex c-form-btns justify-center">

            <div @click="cancel_trip()" v-if="!loading"
              class="pa-1 px-2 light-green lighten-1 d-flex align-center justify-center"
              style="color: white;cursor: pointer">
              <v-icon size="30" color="" style="color: white">mdi-check</v-icon>
              <span>لغو سفر</span>
            </div>

            <div v-if="loading" class="pa-1 px-2 light-green lighten-1 d-flex align-center justify-center"
              style="color: white;cursor: pointer">
              <v-icon size="30" color="white darken-1">mdi-loading mdi-spin</v-icon>
              <span>لغو سفر</span>
            </div>

            <div @click="cancel_trip_btn('f')" class="pa-1 mr-2 px-2 red darken-3 d-flex align-center justify-center"
              style="color: white;cursor: pointer">
              <v-icon size="30" color="" style="color: white">mdi-close</v-icon>
              <span>انصراف</span>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
import SocketListner from "../components/SocketListner.vue";
import { Geolocation } from '@capacitor/geolocation';
export default {
  components: {
    SocketListner,
    AndroidGeolocation,
   },
  name: 'currentService',
  data() {
    return {
      e6: 1,
      dropArea: null,
      list: [],
      issheet_Routing: false,
      issheet_share: false,
      issheet: false,
      audioSrc: '/app/media/service.86ffa798.mp3',
      playing: false,
      file_list: [],
      loading: false,
      loading2: false,
      CurrentLat: 0,
      CurrentLng: 0, items_subcategory: [],
      items_state: [],
      items_city: [],
      param: {
        content: '',
        latitude: '',
        longitude: '',
        category: null,
        sub_category: null,
        main_category: null,
        meter_price: null,
        mortgage_price: null,
        rent_price: null,
        total_price: null,
        building_area: null,
        land_area: null,
        floor: null,
        state: null,
        city: null,
        address: null,
        comment_status: null,
        owner_name: '',
        search_address: null,
        contact: '',
        details: null,
      },
      lat: '',
      lng: '',
      map: null,
      marker_add: 0,
      marker1: null,
      time: '',
      newservice_data: [],
      snackbar: false,
      snackbar2: false,
      iscancel: false,
      text: '',
      service_status: '',
      description: '',
      routing_select: '',
      now_lat: 36.5384078,
      now_lan: 52.674718345862686,
      end_service_form: false,
      StopMinutes: 0,
      ExchangeBTN: false,
      hasReturn: false,
      hasCargo: false,
      ezafebar: false,
      service_amount: 0,
      cargo_price: 0,
      stop_price: 0,
      GrandTotal: 0,
      setting_info: []
    }

  },

  mounted() {
    let self = this;
    this.getInfo();
    this.setting_info = this.$route.params.setting_info;
    this.newservice_data = this.$route.params.obj;
    this.service_status = this.newservice_data.status;
    this.GrandTotal = parseFloat(this.newservice_data.amount.replace(/,/g, ''));
    if (this.$route.params.mode == 'socket') {
      self.play_sound('/app/alrams/service.mp3', 6000)
    }
    console.log('seerviced', this.newservice_data)
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);

    //this.scriptLoad();
    setTimeout(function () {
      self.mapCreate();
      self.mapAction();
      self.dropArea = document.getElementById('drop-area');
    }, 1000);

    this.list[0] = this.newservice_data.origin;
    this.list[1] = this.newservice_data.destination_arr;
    this.list[2] = this.newservice_data.second_destination_arr;

    //set end service form data
    this.StopMinutes = this.newservice_data.stopDuration;
    this.hasCargo = this.newservice_data.hasCargo;
    this.ExchangeBTN = this.newservice_data.hasReturn;
    this.service_price = self.newservice_data.service_price.replace(/,/g, '');
    this.stop_price = self.newservice_data.stop_price.replace(/,/g, '');
    this.cargo_price = self.newservice_data.cargo_price.replace(/,/g, '');
  },

  computed: {
    ...mapGetters(['baseUrl', "auth"]),
    TotalGrandTotal() {

      let res = 0;
      if (this.ExchangeBTN && this.hasCargo) {

        let amount = parseInt(this.service_price) + parseInt(this.stop_price) + parseInt(this.cargo_price);
        res = ((50 / 100) * parseInt(this.service_price)) + amount;
      } else if (this.ExchangeBTN) {

        let amount = parseInt(this.service_price) + parseInt(this.stop_price);
        res = ((50 / 100) * amount) + amount;
      } else if (this.hasCargo) {
        let amount = parseInt(this.service_price) + parseInt(this.stop_price);
        res = amount + parseInt(this.cargo_price);
      } else {

        res = parseInt(this.service_price) + parseInt(this.stop_price)
      }
      return res;
    }

  },
  beforeDestroy() {
    console.log('beforeDestroy');
    SocketListner.disconnect();
  },
  methods: {
    play_sound(src, sec) {
      let self = this;
      self.audioSrc = ''
      if (self.audioSrc === '') {
        self.audioSrc = src;
        self.playing = true;
      }
      setTimeout(function () { self.playing = false }, sec)
    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    }, endservice_btn_form() {
      let self = this;
      self.end_service_form = true
    },
    CalculateKM(mode) {

      let self = this;

      //stop_price
      if (mode == 'stop_price') {
        let stop_price = self.setting_info.stop_price * self.StopMinutes;
        self.stop_price = stop_price;
      }
      //change
      if (mode == 'cargo') {
        if (self.hasCargo)
          self.cargo_price = parseInt(self.setting_info.cargo_price);
        if (!self.hasCargo)
          self.cargo_price = 0;
      }
    },

    mapCreate() {
      let self = this;
      let old_lat = parseFloat(this.newservice_data.destination_arr.lat);
      let old_lng = parseFloat(this.newservice_data.destination_arr.lng);
      let latitud = old_lat !== '' ? old_lat : 35.688428639754235;
      let langtitud = old_lng !== '' ? old_lng : 51.38988018035889;
      // Creating map options
      let mapOptions = {
        center: [latitud, langtitud],
        zoom: 14,
        fullscreenControl: true,
      };
      self.map = new L.map('map', mapOptions); // Creating a map object
      let layer = new L.TileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png'); // Creating a Layer object
      self.map.addLayer(layer); // Adding layer to the map
    },
    mapAction: function () {
      let self = this;
      //var img = new Image();

      if (this.marker_add == 0) {
        self.list.forEach((value, index) => {
          if (index == 0) {
            self.marker1 = new L.Marker([value['lat'], value['lng']], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker1.png" width="60px"/>' +
                  '<span class="my-div-span busy"></span></div>',
              })
            });
            self.marker1.addTo(self.map);
            self.marker1.on('dragend', function () {
              let coord = self.marker1.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              self.param.latitude = lat;
              self.param.longitude = lng;
            });
            this.marker_add = 1;
          }

          if (index == 1) {
            self.marker1 = new L.Marker([value['lat'], value['lng']], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker2.png" width="60px"/>' +
                  '<span class="my-div-span busy"></span></div>',
              })
            });
            self.marker1.addTo(self.map);
            self.marker1.on('dragend', function () {
              let coord = self.marker1.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              self.param.latitude = lat;
              self.param.longitude = lng;
            });
            this.marker_add = 1;
          }

          if (index == 2) {
            self.marker1 = new L.Marker([value['lat'], value['lng']], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker3.png" width="60px"/>' +
                  '<span class="my-div-span busy"></span></div>',
              })
            });
            self.marker1.addTo(self.map);
            self.marker1.on('dragend', function () {
              let coord = self.marker1.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              self.param.latitude = lat;
              self.param.longitude = lng;
            });
            this.marker_add = 1;
          }
          
          index++
        });
      }

    },

    arrive_btn() {
      let self = this;
      self.loading = true
      let newParam =
        'token=' + this.userBox.token +
        '&service_id=' + this.newservice_data.service_id +
        '&uid=' + this.userBox.uid +
        '&public_token=' + this.userBox.public_token;
      console.log('param', newParam)
      self.helperGet('arrive-origin', newParam).then(function (r) {
        console.log('reeee', r.data)
        if (r.data.result == "1") {
          self.snackbar = true
          self.text = 'در انتظار پذیرش مسافر'
          self.service_status = 'waiting_customer';
        }
        self.loading = false
      }).catch(function () {
        self.loading = false
      })

    },

    async startservice_btn() {
      let self = this;
      this.loading = true;
      const position = await Geolocation.getCurrentPosition();
      let newParam =
        'token=' + this.userBox.token +
        '&service_id=' + this.newservice_data.service_id +
        '&uid=' + this.userBox.uid +
        '&public_token=' + this.userBox.public_token +
        '&longitude=' + position.coords.longitude +
        '&latitude=' + position.coords.latitude;
      console.log('param', newParam)
      self.helperGet('start-service', newParam).then(function (r) {
        console.log('reeee', r)
        if (r.data.result == "1") {
          self.snackbar = true
          self.text = 'سرویس آغاز گردید'
          self.service_status = 'moving';
        }
        self.loading = false
      }).catch(function () {
        self.loading = false
      })

    }

    , async endservice_btn() {

      let self = this;
      this.loading2 = true
      let newParam = {};

      try {
        const position = await Geolocation.getCurrentPosition();
        console.log('Current location:', position);
        newParam.lat = position.coords.latitude;
        newParam.lng = position.coords.longitude;
        newParam.token = this.userBox.token;
        newParam.service_id = this.newservice_data.service_id;
        newParam.uid = this.userBox.uid;
        newParam.public_token = this.userBox.public_token;
        newParam.StopMinutes = this.StopMinutes;
        newParam.stop_price = this.stop_price;
        newParam.ExchangeBTN = this.ExchangeBTN;
        newParam.TotalGrandTotal = this.TotalGrandTotal;
        newParam.cargo_price = parseFloat(this.cargo_price);
        newParam.hasCargo = this.hasCargo;

        console.log(newParam);
        self.helperPost('complete-service', newParam).then(function (r) {
          console.log('reeee', r)
          if (r.data.result === "1") {
            self.snackbar = true
            self.text = 'سفر پایان رسید'
            self.service_status = 'end';
            self.$router.push({ path: '/' });
          }
          else {
            self.snackbar2 = true
            self.$toast.warning(r.data.msg);
          }
          self.loading2 = false
        }).catch(function () {
          self.loading2 = false
        })

      } catch (e) {
        console.error('Error getting location', e);
      }
    },
    async startGeolocation() {
      try {
        const position = await Geolocation.getCurrentPosition();
        console.log('Current location:', position);
        this.CurrentLat = position.coords.latitud;
        this.CurrentLng = position.coords.longitud;
      } catch (e) {
        console.error('Error getting location', e);
      }
    },

    cancel_trip_btn(mode) {
      if (mode === 't') {
        this.iscancel = true
      }
      else {
        this.iscancel = false
      }

    },

    cancel_trip() {
      let self = this;
      self.loading = true
      let newParam =
        'token=' + this.userBox.token +
        '&service_id=' + this.newservice_data.service_id +
        '&uid=' + this.userBox.uid +
        '&public_token=' + this.userBox.public_token +
        '&description=' + this.description;
      console.log('param', newParam)
      self.helperGet('cancel-service', newParam).then(function (r) {
        console.log('reeee', r.data)
        if (r.data.result == "1") {
          self.snackbar = true;
          self.text = 'لغو سرویس انجام شد';
          self.$router.push({ name: 'home' });
        } else {
          self.loading = false;
          self.$toast.warning(r.data.msg);
          return false;
        }
        self.loading = false
      }).catch(function () {
        self.loading = false
      })

    },
    masiryabi() {
      let self = this;
      self.issheet_Routing = true
    },
    travel_detail() {
      // let self=this;
      // console.log(this.issheet)
      this.issheet = !this.issheet
    },
    close_modal() {
      this.issheet = false
      this.issheet_Routing = false
      this.issheet_share = false
    },
    get_now_loation() {
      let self = this;
      const success = (position) => {
        let lat = position.coords.latitude;
        let long = position.coords.longitude;

        self.now_lat = lat;
        self.now_lan = long;

        // Do something with the position
      };

      const error = () => {

      };

      // This will open permission popup
      navigator.geolocation.getCurrentPosition(success, error);
    },
    routing(val) {
      this.issheet_Routing = false
      this.issheet_share = true
      this.routing_select = val;
      this.get_now_loation();
    },
    gotomap(platform) {

      let self = this;

      if (platform == 'balad') {
        window.open('https://balad.ir/directions/driving?origin=' + self.now_lan + '%2C' + self.now_lat + '&destination=' + self.list[self.routing_select].lng + '%2C' + self.list[self.routing_select].lat + '#10.94/36.6178/52.730', '_blank');


      }
      if (platform == 'neshan') {
        //window.open('https://neshan.org/maps/@36.536306,52.686238,15.1z,0p/routing/car/origin/'+self.now_lat+','+self.now_lan+'/destination/'+self.list[self.routing_select].lat+','+self.list[self.routing_select].lng+'/poi_hash/c3de42e1a4cbc16b0405d801d7c14858', '_blank');
        window.open(`geo:${self.list[self.routing_select].lat},${self.list[self.routing_select].lng}`);

      }
    }
  }

};
</script>

<style scoped>
.page-f {
  height: calc(100vh - 116px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bottom-btns {
  text-align: center;
  color: white;
  width: 32%;
  height: 50px;
  cursor: pointer;
  font-size: 15px;
  line-height: 50px;
  border-radius: 5px;
  font-weight: normal;
}

.close-btn {
  width: 50px;
  height: 6px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #ccc;
  text-align: center;
  margin-top: 6px;
  cursor: pointer;
}

.service-option {
  flex-shrink: 0;


}

.c-form-btns div {

  font-size: 14px;
  border-radius: 5px;
}

.sheet-h-24 {
  height: 24%;
}

.sheet-h-34 {
  height: 34%;
}
</style>
